// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class CouponDocumentsSubmitDocumentsSubmitDocumentsResponse {
    static getAttributeTypeMap() {
        return CouponDocumentsSubmitDocumentsSubmitDocumentsResponse.attributeTypeMap;
    }
}
CouponDocumentsSubmitDocumentsSubmitDocumentsResponse.discriminator = undefined;
CouponDocumentsSubmitDocumentsSubmitDocumentsResponse.additionalProperties = false;
CouponDocumentsSubmitDocumentsSubmitDocumentsResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "ExtClaimSubmitClaimResultModel"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
];
//# sourceMappingURL=couponDocumentsSubmitDocumentsSubmitDocumentsResponse.js.map